<template>
  <card
    v-if="client"
    class="card"
    :title="`Cliente (${client.id}) ${client.name}`"
  >
    <div>
      <form @submit.prevent="create" novalidate>
        <span
          >Altere entre as opções abaixo para mudar o
          <strong>tipo de plano de mensalidade</strong></span
        >
        <div class="row col-md-6">
          <input
            type="radio"
            id="planos"
            name="fav_language"
            value="plan"
            v-model="planType"
            checked
          />
          <label class="text-span" for="planos"
            ><span class="mg-left">Single</span></label
          ><br />
          <input
            class="gap-left"
            type="radio"
            id="combos"
            name="fav_language"
            value="combo"
            v-model="planType"
          />
          <label class="text-span" for="combos"
            ><span class="mg-left">Combo</span></label
          ><br />
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group" v-if="planType === 'plan'">
              <label for="exampleFormControlTextarea1"
                >Plano de Mensalidade</label
              >
              <select
                class="form-control input i-width"
                v-model="body.planId"
                @change="onPlanIdChange"
                required
              >
                <option :value="null" selected disabled>Selecione...</option>
                <template v-for="optgroup in plansByGroup">
                  <optgroup
                    v-if="optgroup.groupId"
                    :label="optgroup.groupName"
                    :key="optgroup.groupId"
                  >
                    <option
                      v-for="plan in optgroup.plans"
                      :value="plan.planId"
                      :key="plan.planId"
                    >
                      {{ plan.name }}
                    </option>
                  </optgroup>
                </template>
              </select>
            </div>
            <div class="form-group" v-if="planType === 'combo'">
              <label for="exampleFormControlTextarea1"
              >Plano de Mensalidade</label
              >
              <select
                class="form-control input i-width"
                v-model="comboId"
                @change="onPlanIdChange"
                required
              >
                <option :value="null" selected disabled>Selecione...</option>
                <option
                  v-for="combo in combos"
                  :value="combo.id"
                  :key="combo.id"
                >
                  {{ combo.name }}
                </option>
            </select>
          </div>
            <div v-if="combo && planType === 'combo'">
              <button class="btn-preview" type="button" @click="showComboPreview = !showComboPreview">{{!showComboPreview ? 'Visualizar' : 'Ocultar'}} combo</button>
              <div v-if="showComboPreview">
                <CardPlan
                  :name="combo.name"
                  :internet-plan="combo.internetPlan"
                  :tv-plan="combo.tvPlan"
                  :phone-plan="combo.phonePlan"
                />
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label for="exampleFormControlTextarea1"
                >Carteira de Cobrança</label
              >
              <select
                v-model="body.cobCart"
                class="form-control input i-width"
                required
              >
                <option :value="null" selected disabled>Selecione...</option>
                <option v-for="f in field.cobCarts" :key="f.id" :value="f.id">
                  {{ f.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="exampleFormControlTextarea1">Dia de Vencimento</label>
              <select
                class="form-control input i-width"
                v-model="body.expireDay"
                required
              >
                <option :value="null" selected disabled>Selecione...</option>
                <option
                  v-for="f in field.expirationDates"
                  :key="f.id"
                  :value="f.id"
                >
                  {{ f.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-3">
            <fg-input
              type="date"
              label="Agendamento OS"
              v-model="body.date"
              required
            ></fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label for="exampleFormControlTextarea1">Vendedor</label>
              <select
                class="form-control input i-width"
                v-model="body.seller"
                required
              >
                <option :value="null" selected disabled>Selecione...</option>
                <option v-for="f in field.sellers" :key="f.id" :value="f.id">
                  {{ f.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <hr />

        <div>
          <input type="checkbox" v-model="body.useClientAddress" />
          <label style="margin-left: 5px" for="endereço">
            <span style="font-weight: bold"
              >Usar mesmo endereço cadastrado no cliente</span
            >
          </label>
        </div>
        <br />
        <div v-show="!body.useClientAddress">
          <div>
            <span class="address">Endereço do Novo Ponto</span>
          </div>
          <br />
          <div class="row">
            <div class="col-md-3">
              <fg-input
                type=""
                label="CEP"
                v-mask="'########'"
                v-model="body.zipCode"
                required
              ></fg-input>
            </div>

            <div class="col-md-6">
              <fg-input
                type="text"
                label="Endereço"
                @keyup.native="toUpperAddress"
                v-model="body.address"
                required
              ></fg-input>
            </div>
            <div class="col-md-2">
              <fg-input
                type="number"
                label="Número"
                v-model="body.addressNumber"
                required
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <fg-input
                type=""
                label="Cidade"
                @keyup.native="toUpperCity"
                v-model="body.city"
                required
              ></fg-input>
            </div>

            <div class="col-md-2">
              <fg-input
                type="text"
                label="Bairro"
                @keyup.native="toUpperDistrict"
                v-model="body.district"
                required
              ></fg-input>
            </div>
            <div class="col-md-7">
              <fg-input
                type="text"
                label="Complemento"
                @keyup.native="toUpperAddressExtra"
                v-model="body.addressExtra"
                required
              ></fg-input>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label for="exampleFormControlTextarea1">Condomínio</label>
              <select
                class="form-control input i-width"
              >
                <option :value="null" selected disabled>Selecione...</option>
                <option v-for="f in condos" :key="f.id" :value="f.id">
                  {{ f.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Observações O.S</label>
              <textarea
                rows="2"
                class="form-control border-input"
                v-model="body.observations"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <div>
              <input
                type="checkbox"
                id="fidelidade"
                name="fidelidade"
                v-model="body.loyalty"
              />
              <label style="margin-left: 5px" for="fidelidade">
                <span class="text-span">Ponto possui fidelidade ?</span>
              </label>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>

        <div class="container_buttons">
          <button class="btn-custom btn-salvar" v-show="showRegisterButton">
            Criar Ponto
          </button>
          <button
            @click="getScore"
            type="button"
            class="btn-custom btn-analise"
          >
            Análise Crédito
          </button>
        </div>
      </form>
    </div>
  </card>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import CardPlan from "@/components/Plans/CardPlan.vue";
export default {
  components: { CardPlan },
  computed: {
    combos() {
      return this.$store.getters.combos;
    },
    condos() {
      return this.$store.getters.condos;
    },
    client() {
      return this.$store.getters.client;
    },
    plans() {
      return this.$store.getters.plans.filter(p => this.combos.every(c => c.internetPlanId !== p.planId));
    },
    field() {
      return this.$store.getters.leadFields;
    },
    combo() {
      return this.combos.find(c => c.id === this.comboId);
    }
  },
  methods: {
    ...mapActions([
      "fetchClient",
      "fetchPlans",
      "createPoint",
      "fetchLeadFields",
      "fetchScore",
      "fetchCombos",
      "fetchCondos"
    ]),
    async create() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      try {
        const date = this.body.date
        if (this.planType === 'plan') {
          await this.createPoint({
            body: { ...this.body, clientId: Number(this.$route.params.id), date },
          });
        } else if (this.planType === 'combo') {
          const combo = this.combos.find(c => c.id === this.comboId);
          if (!combo) {
            throw new Error('Combo não encontrado');
          }
          if (combo.internetPlanId) {
            this.body.planId = combo.internetPlanId;
            await this.createPoint({
              body: { ...this.body, clientId: Number(this.$route.params.id), date },
            });
          }
          if (combo.tvPlanId) {
            this.body.planId = combo.tvPlanId;
            await this.createPoint({
              body: { ...this.body, clientId: Number(this.$route.params.id), date },
            });
          }
          if (combo.phonePlanId) {
            this.body.planId = combo.phonePlanId;
            await this.createPoint({
              body: { ...this.body, clientId: Number(this.$route.params.id), date },
            });
          }
        } else {
          throw new Error('Tipo de plano inválido');
        }
        Swal.fire("Sucesso!", "Ponto cadastrado com sucesso", "success");
        this.$router.push(`/clientes/${this.$route.params.id}/visualizar`);
      } catch (err) {
        Swal.fire("Ops!", "Não foi possível cadastrar o ponto", "error");
      } finally {
        this.loading = false;
      }
    },
    onPlanIdChange() {
      this.showRegisterButton = false;
    },
    async getScore() {
      const combo = this.combos.find(c => c.id === this.comboId);
      const planId = combo ? combo.internetPlanId : this.body.planId;
      if (!planId) {
        await Swal.fire(
          "Ops!",
          "Selecione o plano antes de consultar",
          "warning"
        );
        return;
      }
      try {
        if (this.loading) {
          return;
        }
        this.loading = true;

        Swal.fire({
          title: "Analisando!",
          html: "Analisando crédito...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const response = await this.fetchScore({
          id: this.$route.params.id,
          planId,
          type: "client",
          loyalty: this.body.loyalty,
        });
        Swal.close();

        if (response.allowed === false) {
          await Swal.fire(
            "Não aprovado!",
            "Esse cliente não foi aprovado na análise de crédito",
            "warning"
          );
        } else {
          let text = `A taxa de instalação desse cliente é de R$${response.fee}, pagamento no ato da instalação (preferencialmente técnico terceiro).`;
          if (response.fee === 0) {
            text = `Instalação gratuita (preferencialmente técnico interno).`;
          }
          await Swal.fire({
            title: "Aprovado",
            icon: "success",
            text,
            showCloseButton: false,
            showCancelButton: false,
            cancelButtonText: "Fechar",
          });

          this.showRegisterButton = true;
        }
      } catch (er) {
        Swal.close();
        if (er.response && er.response.status === 422) {
          Swal.fire(
              "Ops!",
              "O CPF/CNPJ informado não é válido, verifique e tente novamente",
              "error"
          );
        } else {
          await Swal.fire(
            "Ops!",
            "Não foi possível analisar o crédito deste cliente",
            "error"
          );
        }
      } finally {
        this.loading = false;
      }
    },
    toUpperAddress(e) {
      this.body.address = e.target.value.toUpperCase();
    },
    toUpperCity(e) {
      this.body.city = e.target.value.toUpperCase();
    },
    toUpperDistrict(e) {
      this.body.district = e.target.value.toUpperCase();
    },
    toUpperAddressExtra(e) {
      this.body.addressExtra = e.target.value.toUpperCase();
    },
    fillPlansByGroup() {
      const groupNames = new Map([
        [27, "Internet"],
        [28, "Global Móvel"],
        [29, "TV"],
        [30, "Telefone"],
        [33, "Internet NK"],
        [34, "Ponto Adicional"],
        [35, "Serviços de TI"],
      ]);
      this.plans.forEach((plan) => {
        const index = this.plansByGroup.findIndex(
          (p) => p.groupId === plan.groupId
        );
        if (index > -1) {
          this.plansByGroup[index].plans.push(plan);
          this.plansByGroup[index].plans.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
        } else {
          this.plansByGroup.push({
            groupId: plan.groupId,
            groupName: groupNames.get(plan.groupId) || plan.groupId,
            plans: [plan],
          });
        }
      });
      return this.plansByGroup;
    },
  },
  data() {
    return {
      body: {
        loyalty: false,
        planId: null,
        cobCart: null,
        date: "",
        zipCode: "",
        address: "",
        city: "",
        district: "",
        addressNumber: "",
        addressExtra: "",
        useClientAddress: false,
        observations: "",
        expireDay: null,
        seller: null,
        condominium: null,
      },
      planType: 'plan',
      comboId: null,
      showRegisterButton: false,
      loading: false,
      plansByGroup: [],
      showComboPreview: false,
    };
  },
  async mounted() {
    await Promise.all([
      this.fetchPlans(),
      this.fetchLeadFields(),
      this.fetchClient({ id: this.$route.params.id }),
      this.fetchCombos(),
      this.fetchCondos(),
    ]);
    this.fillPlansByGroup();
  },
};
</script>

<style lang="scss" scoped>
input[type="radio"] {
  width: 18px;
}
.text-span {
  font-weight: bold;
  color: #000;
  font-size: 18px;
}
.gap-left {
  margin-left: 10px;
}
.mg-left {
  margin-left: 3px;
}
span.address {
  font-size: 22px;
  font-weight: bold;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-salvar {
    background: #9dcf6b;
    padding: 13px 25px;
    &:hover {
      background: #82ac58;
    }
  }

  &.btn-analise {
    margin-left: 10px;
    background: orange;
    &:hover {
      background: #c07e03;
    }
  }
}
.btn-preview {
  border: none;
  padding: 10px 20px;
  background-color: #E1DEDD;
  font-size: 13px;
  border-radius: 5px;
}
</style>
